// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/astroturf/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n  ._2aM8m-4Xx92dNWnaEGRNME {\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    background: #373737;\n    padding: 2px;\n    width: 100%;\n  }\n  ._3HEPmFe0KP_qc9LRO7uwIh {\n    color: white;\n    margin: 8px 24px 8px 24px;\n  }\n  .yr0iF51zaJ_HOYfzQrmAp {\n    margin-left: auto;\n    margin-right: 24px;\n  }\n  label {\n    color: white;\n  }\n  ._2HSpHXCXB2uWq9tBHwycOe:hover {\n    text-decoration: underline;\n    cursor: pointer;\n  }\n", ""]);
// Exports
exports.locals = {
	"menubar": "_2aM8m-4Xx92dNWnaEGRNME",
	"title": "_3HEPmFe0KP_qc9LRO7uwIh",
	"debugMenu": "yr0iF51zaJ_HOYfzQrmAp",
	"mapLink": "_2HSpHXCXB2uWq9tBHwycOe"
};
module.exports = exports;
